import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import { connect } from 'react-redux';
import { CMS_CTA_TYPES } from 'components/CmsPage/modules/CmsCta';
import { buildFriendbuyInterpolator } from 'components/Friendbuy/FriendbuyWidget';
import { DEFAULT_PAGE_PROMOTION_SESSION_KEY } from 'components/PagePromotion/PagePromotionCta';
import { GET_CLASSPASS_DEFAULT_PROMOTION_ALIAS } from 'constants/promotions';
import trackDwell from 'decorators/TrackDwell/TrackDwell';
import { withSagas } from 'decorators/Sagas/Sagas';
import { decorateWith } from 'helpers/decorator';
import { interpolate } from 'helpers/interpolate';
import { isBlank, isEmpty } from 'helpers/verify';
import { setPagePromotion, useSellHeader } from 'redux/modules/page';
import { isLoggedIn } from 'redux/modules/user';
import { friendbuy } from 'redux/saga/entities/bound';
import { readSessionStorage } from 'redux/saga/helpers/local-storage';
import { selectCmsPath } from 'redux/saga/selectors/cms';
import { HeroV2 } from './HeroV2';
import { ctaClick, loadSaga, watchSaga } from './herov2.saga';

var mapCtas = function mapCtas(_ref, promoAlias) {
  var ctas = _ref.ctas,
      callToAction = _ref.callToAction,
      callToActionYouTube = _ref.callToActionYouTube;
  return (isEmpty(ctas) ? [callToAction || {}, callToActionYouTube || {}] : ctas).map(function (cta) {
    return cta.type === CMS_CTA_TYPES.URL && !cta.url ? (cta.url = promoAlias ? "/pricing/".concat(promoAlias) : '/pricing', cta) : cta;
  });
};

var mapPromoAlias = function mapPromoAlias(_ref2) {
  var promotionAlias = _ref2.promotionAlias;

  // Check to see if we are overriding the default promotion with
  // an Optimizely-provided one.
  if (promotionAlias === GET_CLASSPASS_DEFAULT_PROMOTION_ALIAS) {
    var sessionPromotionAlias = readSessionStorage(DEFAULT_PAGE_PROMOTION_SESSION_KEY, null, true);

    if (!isBlank(sessionPromotionAlias)) {
      return sessionPromotionAlias;
    }
  }

  return promotionAlias;
};

export var mapStateToProps = function mapStateToProps(state, ownProps) {
  var cmsPath = selectCmsPath(state);
  var referAFriend = friendbuy.data(state, friendbuy.lastLoadedKey(state)) || {};
  var isRaf = cmsPath.indexOf('/referral') === 0 || cmsPath === '/homepage' && !isEmpty(referAFriend);
  var isWelcomeHero = !!ownProps.isWelcomeHero && isLoggedIn(state);
  var promoAlias = mapPromoAlias(ownProps);
  var ctas = mapCtas(ownProps, promoAlias);
  var hideHeaderCta = ownProps.hideHeaderCta || isLoggedIn(state);

  var interpolator = function interpolator(text) {
    return text;
  };

  if (isWelcomeHero) {
    interpolator = buildFriendbuyInterpolator(state);
  } else if (isRaf) {
    var senderReward = referAFriend.sender_reward || referAFriend.currency_symbol + referAFriend.reward_amount;
    var receiverReward = referAFriend.receiver_reward || referAFriend.currency_symbol + referAFriend.reward_amount;

    interpolator = function interpolator(text) {
      return interpolate(text, {
        $RECEIVER_REWARD: receiverReward,
        $SENDER_FIRST_NAME: referAFriend.referrer_first_name,
        $SENDER_REWARD: senderReward
      });
    };
  }

  return {
    horizontalAlignment: ownProps.alignment,
    ctas: ctas,
    desktopImageUrl: ownProps.desktopImage,
    headerCtaCopy: ownProps.headerCtaCopy,
    heroTextColor: ownProps.heroTextColor || 'dark',
    hideHeaderCta: hideHeaderCta,
    interpolator: interpolator,
    isLeadCapture: !!ownProps.leadCapture,
    isRaf: isRaf,
    isWelcomeHero: isWelcomeHero,
    legal: ownProps.legal,
    mobileImageUrl: ownProps.mobileImage,
    promoAlias: promoAlias,
    subtitle: ownProps.subtitle || [],
    title: ownProps.title || [],
    titleSize: ownProps.titleSize || 'display'
  };
};
export var mapDispatchToProps = {
  ctaClick: ctaClick,
  setPagePromotion: setPagePromotion,
  useSellHeader: useSellHeader
};
export var HeroV2Container = decorateWith(trackDwell, withSagas({
  watch: watchSaga,
  load: loadSaga
}), connect(mapStateToProps, mapDispatchToProps))(HeroV2);